import * as actions from "./content.actions";
import * as mutations from "./content.mutations";
import * as getters from "./content.getters";
import state from "./content.state";
// make our modules namespaced to avoid method name conflicts
const namespaced = true;

const content = {
  namespaced,
  getters,
  mutations,
  actions,
  state
};

export default content;
